<template>
	<nav class="gw-nav" aria-label="Primary navigation">
		<div class="gw-nav__inner">
			<router-link to="/" class="gw-brand" aria-label="gb-whatsapp.cc home">
				<img src="@/assets/gb-whatsapp-guide.webp" alt="">
				<span>gb-whatsapp.cc</span>
			</router-link>

			<button
				class="gw-menu-toggle"
				type="button"
				:aria-expanded="isMenuOpen ? 'true' : 'false'"
				aria-label="Toggle navigation menu"
				@click="isMenuOpen = !isMenuOpen"
			>
				<img :src="isMenuOpen ? closeIcon : menuIcon" :alt="isMenuOpen ? 'Close menu' : 'Open menu'">
			</button>

			<ul class="gw-nav__links" :class="{ 'is-open': isMenuOpen }">
				<li>
					<router-link to="/" exact @click.native="isMenuOpen = false">Home</router-link>
				</li>
			</ul>
		</div>
	</nav>
</template>

<script>
import menuIcon from '@/assets/menu.svg';
import closeIcon from '@/assets/xmark-black.svg';

export default {
	name: 'HeadNav',
	data() {
		return {
			isMenuOpen: false,
			menuIcon,
			closeIcon,
		};
	},
};
</script>

<style lang="scss" scoped>
.gw-nav {
	position: sticky;
	top: 0;
	z-index: 1000;
	border-bottom: 1px solid #dce6e1;
	background: rgba(255, 255, 255, 0.96);
	box-shadow: 0 8px 24px rgba(15, 46, 39, 0.05);
	backdrop-filter: blur(12px);
}

.gw-nav__inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: min(1120px, calc(100% - 40px));
	min-height: 72px;
	margin: 0 auto;
}

.gw-brand {
	display: inline-flex;
	align-items: center;
	gap: 10px;
	color: #10241f;
	font-size: 19px;
	font-weight: 800;
	letter-spacing: 0;

	img {
		width: 38px;
		height: 38px;
		border-radius: 8px;
	}
}

.gw-nav__links {
	display: flex;
	align-items: center;
	gap: 6px;
	margin: 0 !important;
	padding: 0;
	list-style: none !important;

	li {
		list-style: none;
	}

	a {
		display: inline-flex;
		align-items: center;
		min-height: 40px;
		padding: 0 14px;
		border-radius: 6px;
		color: #31433e;
		font-size: 15px;
		font-weight: 600;
	}

	a:hover,
	a:focus,
	a.router-link-active {
		background: #edf7f3;
		color: #0b6f61;
	}
}

.gw-menu-toggle {
	display: none;
	width: 42px;
	height: 42px;
	align-items: center;
	justify-content: center;
	border: 1px solid #d8e4df;
	border-radius: 6px;
	background: #fff;
	cursor: pointer;

	img {
		width: 21px;
		height: 21px;
	}
}

@media (max-width: 860px) {
	.gw-nav__inner {
		width: min(100% - 28px, 1120px);
		min-height: 64px;
	}

	.gw-menu-toggle {
		display: inline-flex;
	}

	.gw-nav__links {
		position: absolute;
		top: 100%;
		right: 0;
		left: 0;
		display: none;
		flex-direction: column;
		align-items: stretch;
		gap: 0;
		padding: 10px 14px 16px;
		border-bottom: 1px solid #dce6e1;
		background: #fff;
		box-shadow: 0 14px 24px rgba(15, 46, 39, 0.08);

		&.is-open {
			display: flex;
		}

		li {
			width: 100%;
		}

		a {
			justify-content: center;
			width: 100%;
			min-height: 46px;
			border-radius: 4px;
		}
	}
}
</style>
